// @flow

import * as React from 'react';
import { OverflowUI, OverflowUIList } from '@ta/social.overflow-ui';
import ProfileOverflowSelector, { type DataProps } from './ProfileOverflowSelector';

/** A wrapper component for an overflow menu to display options for a particular profile
 * Currently only supports blocking/unblocking, but will support reports as well.
 * */

type ExternalProps = {|
  ...DataProps,
  /** The class of the container <div/> */
  className?: string,
|};

const ProfileOverflowMenu = ({
  profileUserId,
  displayName,
  isBlocking,
  className,
}: ExternalProps) => (
  <ProfileOverflowSelector
    profileUserId={profileUserId}
    displayName={displayName}
    isBlocking={isBlocking}
  >
    {overflowItems =>
      overflowItems.length > 0 ? (
        <OverflowUI className={className}>
          <OverflowUIList>{overflowItems}</OverflowUIList>
        </OverflowUI>
      ) : null
    }
  </ProfileOverflowSelector>
);

ProfileOverflowMenu.defaultProps = {
  className: undefined,
};

export default ProfileOverflowMenu;
